// extracted by mini-css-extract-plugin
module.exports = {"mainbox":"Partnership_mainbox__5asQV","swiperc":"Partnership_swiperc__lz_4Z","test":"Partnership_test__Fq-uD"};